import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import history from '../authentication/History';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';


const styles = theme => ({
  
});

class Map extends Component {

  navigateToSticker(id) {
    history.push("/stickers/" + id);
  }

  render() {
    const GoogleMapsComponent = withGoogleMap(props => (
      <GoogleMap
        center = { { lat: 51.1642292, lng: 10.4541194 } }
        defaultZoom = { 6 }>
          {props.locations.map((location, index) =>
            <Marker key={location.identifier} position={{ lat: location.lat, lng: location.lon }} title={location.identifier} onClick={() => this.navigateToSticker(location.uuid) } />
          )}
      </GoogleMap>
    ));
    return (
      <div>
        <GoogleMapsComponent
          locations={this.props.locations}
          containerElement={ <div style={{ height: `700px`, width: '100%' }} /> }
          mapElement={ <div style={{ height: `100%` }} /> }
        />
      </div>
    );
  }
};

class StickerMap extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }

  componentDidMount() {
    this.props.stickerStore.getStickerMap();
  }

  render() {
    return (
      <div>
        <Grid container
          direction="row"
          justify="flex-start"
          alignItems="flex-start">
          <Grid item xs={12} lg={12}>
            {this.props.stickerStore.stickerMap.length > 0 &&
              <Map locations={this.props.stickerStore.stickerMap} />
            }
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(observer(StickerMap));